export class TransferBalanceModel {
    accountId: string = '';
    value: number = 0;
    payerName = '';
}